export default "__VITE_ASSET__d39b7e6e__"